const ACTIONS = {
  GET_RAFFLE_WINNER: "getRaffleWinner",
  GET_MAOR_WINNER: "getMaorWinner",
};

export { ACTIONS };
